// ────────────────────────────────────────────────────────────────
//  Client Experiences — verified Google reviews
//  Add future reviews by appending to REVIEWS. The page + homepage
//  section scale automatically (5 → 50+) with no layout changes.
// ────────────────────────────────────────────────────────────────

// John Campbell Insurance — Google Business Profile "write/see reviews" link.
export const GOOGLE_REVIEWS_URL = "https://g.page/r/Cc7H1n7OvXneEAE/review";

export const GOOGLE_RATING = "5.0";

export const REVIEWS = [
  {
    id: "gregory-jerger",
    name: "Gregory Jerger",
    rating: 5,
    featured: true,
    text:
      "Working with John Campbell was truly a wonderful experience. He helped my wife, Cathy and me secure life insurance policies that give us peace of mind about our family's future. John was knowledgeable, patient, professional, and genuinely cared about making sure we understood our coverage and felt comfortable with our decisions. He made the entire process simple and stress-free. We are extremely grateful for his excellent service and highly recommend John Campbell to anyone looking for a trustworthy life insurance agent who truly puts his clients first.",
  },
  {
    id: "roger-friend",
    name: "Roger Friend",
    rating: 5,
    text:
      "Campbell contacted me immediately after my life insurance inquiry. He was persistent in a good way. Helping me to stay the course. He sensed my intrepidations of doing business without personally meeting him. So he said \u201Chey let's grab coffee\u201D, getting to know him, I found him to be a fantastic guy with a life story that gives a caring presence, asking the right questions and professional. I am thankful for my new friend in the insurance business.",
  },
  {
    id: "bryan-petersen",
    name: "Bryan Petersen",
    rating: 5,
    text:
      "John made the entire process simple and stress-free. He took the time to answer all of my questions, never pressured me, and helped me find the right life insurance coverage for my needs. I highly recommend John Campbell Insurance to anyone looking for honest, professional service.",
  },
  {
    id: "allyn-barnum",
    name: "Allyn Barnum",
    rating: 5,
    text:
      "John is a true professional and will provide excellent service. He demonstrated extra effort and care in obtaining a tailored policy for my needs. I would highly recommend John. You too will become an advocate of him and his business once you work with him.",
  },
  {
    id: "elizabeth-freudenberger",
    name: "Elizabeth Freudenberger",
    rating: 5,
    text:
      "Polished, professional and efficient! Thankful to have John Campbell as our insurance broker. Appreciate his service and trustworthiness.",
  },
];

export const FEATURED_REVIEW = REVIEWS.find((r) => r.featured) || REVIEWS[0];
export const GRID_REVIEWS = REVIEWS.filter((r) => r.id !== FEATURED_REVIEW.id);
// Three concise-first reviews surfaced on the homepage.
export const HOME_REVIEWS = REVIEWS.slice(0, 3);
